import { observer } from 'mobx-react-lite';
import * as React from 'react';

import MobileToolCallHistoryDrawer from '@/components/shared/MobileToolCallHistoryDrawer';
import ToolCallHistoryDrawer from '@/components/shared/ToolCallHistoryDrawer';
import { useOrganizationChatAiPageStore } from '@/stores/local/pages/OrganizationChatAiPageStore';
import { useDevices } from '@/utils/devices';

const NESTED_TOOL_HISTORY_Z_INDEX = 400;

/**
 * История вызовов инструментов для панели чата над документом.
 * Должна быть внутри OrganizationChatAiPageStoreProvider.
 * На десктопе drawer открывается слева — как основной ChatPanel.
 */
const ChatPanelToolCallDrawers: React.FC = observer(() => {
  const { isCompactViewport } = useDevices();
  const store = useOrganizationChatAiPageStore();

  return isCompactViewport ? (
    <MobileToolCallHistoryDrawer
      opened={store.toolCallHistory.isOpen}
      onClose={store.toolCallHistory.close}
      steps={store.activeToolCallHistorySteps}
      durationLabel={store.activeToolCallHistoryDurationLabel}
      zIndex={NESTED_TOOL_HISTORY_Z_INDEX}
    />
  ) : (
    <ToolCallHistoryDrawer
      opened={store.toolCallHistory.isOpen}
      onClose={store.toolCallHistory.close}
      steps={store.activeToolCallHistorySteps}
      durationLabel={store.activeToolCallHistoryDurationLabel}
      zIndex={NESTED_TOOL_HISTORY_Z_INDEX}
      position="left"
    />
  );
});

export default React.memo(ChatPanelToolCallDrawers);
